import { IRequestCommand } from '../../authentication/connection/iRequestCommand';
import { ErrorDetails } from '../../authentication/connection/interfaces/apiInterfaces';
import { CommandRequestType } from '../../authentication/connection/commandRequestType';
import { ICommandResponse } from '../../authentication/connection/iCommandResponse';

export class PutEmailTemplateActiveCommand extends IRequestCommand<
  IPutEmailTemplateActiveCommandResponse,
  ErrorDetails,
  IPutEmailTemplateActiveCommandParameters> {
  override _commandType: CommandRequestType = CommandRequestType.PUT;
  override _commandUrl = 'carriers/{carrierId}/emailsTemplates/active';

  public override setParameters(parameters: IPutEmailTemplateActiveCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierId}',
      parameters.carrierId ? parameters.carrierId.toString() : ''
    );
    this._commandBody = parameters;
  }
}

export interface IPutEmailTemplateActiveCommandParameters {
  carrierId: number;
  id: number;
  active: boolean;
  html: string;
  languageCode: string;
  logoPlacement: string;
  userId: number;
  userType: string;
}

export interface IPutEmailTemplateActiveCommandResponse extends ICommandResponse {
}
